var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.027,
    height: 10.12,
    viewBox: "0 0 13.027 10.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logs",
    transform: "translate(-1852.872 -528.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8664",
    "data-name": "Path 8664",
    d: "M1862.157,529.936h5.123a.531.531,0,0,0-.006-1.061h-5.12a.531.531,0,0,0,0,1.061Z",
    transform: "translate(-1.879)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8665",
    "data-name": "Path 8665",
    d: "M1867.532,532.719h-4.172a.531.531,0,0,0,.006,1.061h4.169a.531.531,0,0,0,0-1.061Z",
    transform: "translate(-2.138 -0.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8666",
    "data-name": "Path 8666",
    d: "M1865.4,540.4h-11.834a.531.531,0,0,0,0,1.061H1865.4a.531.531,0,0,0,0-1.061Z",
    transform: "translate(-0.037 -2.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8667",
    "data-name": "Path 8667",
    d: "M1867.456,536.56h-4.6a.533.533,0,0,0,.012,1.06h4.6a.534.534,0,0,0-.007-1.061Z",
    transform: "translate(-2.036 -1.645)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8668",
    "data-name": "Path 8668",
    d: "M1856.5,532.587a1.837,1.837,0,1,0-1.837-1.838A1.839,1.839,0,0,0,1856.5,532.587Zm0-.917a.917.917,0,1,1,0-1.834h.038a.917.917,0,0,1-.038,1.834Z",
    transform: "translate(-0.384 -0.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8669",
    "data-name": "Path 8669",
    d: "M1853.3,538.035l.038,0h0a.461.461,0,0,0,.456-.4,2.346,2.346,0,0,1,4.654,0,.46.46,0,0,0,.917-.061.325.325,0,0,0,0-.058,3.267,3.267,0,0,0-6.483,0,.46.46,0,0,0,.4.513Z",
    transform: "translate(0 -1.239)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogs);
export default __webpack_public_path__ + "static/media/Logs.ba1f375e.svg";
export { ForwardRef as ReactComponent };